var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArraow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1037_15001",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.443848,
    y: 0.359863,
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1037_15001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4437 32.6514L34.8187 23.2764L31.8499 20.3597L25.4437 26.7659L19.0374 20.3597L16.0687 23.2764L25.4437 32.6514ZM25.4437 46.193C22.5617 46.193 19.8534 45.6458 17.3187 44.5514C14.784 43.4583 12.5791 41.9743 10.7041 40.0993C8.8291 38.2243 7.34507 36.0194 6.25202 33.4847C5.15757 30.95 4.61035 28.2416 4.61035 25.3597C4.61035 22.4778 5.15757 19.7694 6.25202 17.2347C7.34507 14.7 8.8291 12.4951 10.7041 10.6201C12.5791 8.74512 14.784 7.26039 17.3187 6.16595C19.8534 5.07289 22.5617 4.52637 25.4437 4.52637C28.3256 4.52637 31.034 5.07289 33.5687 6.16595C36.1034 7.26039 38.3083 8.74512 40.1833 10.6201C42.0583 12.4951 43.5423 14.7 44.6353 17.2347C45.7298 19.7694 46.277 22.4778 46.277 25.3597C46.277 28.2416 45.7298 30.95 44.6353 33.4847C43.5423 36.0194 42.0583 38.2243 40.1833 40.0993C38.3083 41.9743 36.1034 43.4583 33.5687 44.5514C31.034 45.6458 28.3256 46.193 25.4437 46.193Z",
    fill: "#2165A2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArraow);
export default __webpack_public_path__ + "static/media/DownArraow.9959d89f0b83de7763e03d628a2107da.svg";
export { ForwardRef as ReactComponent };